/* eslint-disable */
export default {
  title: 'Rép. avec message vocal',
  customMessage: 'Message personnalisé',
  customMessagePlaceholder: 'Entrez un message personnalisé',
} as const;

// @key: @#@"title"@#@ @source: @#@"Reply with Voice Message"@#@
// @key: @#@"customMessage"@#@ @source: @#@"Custom message"@#@
// @key: @#@"customMessagePlaceholder"@#@ @source: @#@"Type a custom message"@#@
